export const JIRA_BASE = 'https://contentsquare.atlassian.net/browse';

export function severityClass(severity) {
  const lower = (severity ?? '').toLowerCase();
  if (lower.includes('critical')) return 'severity-critical';
  if (lower.includes('major')) return 'severity-major';
  if (lower.includes('minor')) return 'severity-minor';
  return '';
}

export function statusClass(status) {
  if (status === 'Done') return 'done';
  if (status === 'Backlog') return 'backlog';
  return 'default';
}
